import React from 'react';
import classNames from 'classnames/bind';
import Button from '../../atoms/button';
import styles from './index.pcss';

interface OptionType {
  id: number;
  imageUrl: string;
  subText: string;
  text: string;
}

interface RatingFeedBackQAProps {
  question: string;
  selected: number | string;
  options: OptionType[];
  onClickHandler: (eachOption: number) => void;
  variant: 'desktop' | 'mobile';
  index:number
}

const cx = classNames.bind(styles);
const RatingFeedBackQA = ({
  question = '',
  selected,
  options,
  variant,
  onClickHandler,
  isFleek = false,
  index
}: RatingFeedBackQAProps) => {
  const clickHandler = (selectedOption: number) => {
    onClickHandler(selectedOption);
  };
  const isDesktop = variant === 'desktop';
  return (
    <div className={cx(`rating-feedback-container-${isDesktop ? 'desktop' : 'mobile'}`)}>
      <p
        id={`ratingQuestion-${index}`}
        className={cx('rating-question', isFleek && 'fleek-rating-question')}
        role="heading"
        aria-level={3}
      >
        {question}
      </p>
      <div className={cx('options-container')} role="radiogroup" aria-labelledby={`ratingQuestion-${index}`}>
        {options.map(eachOption => {
          if (isDesktop) {
            return (
              <button
                key={eachOption.id}
                onClick={() => {
                  clickHandler(eachOption.id);
                }}
                className={cx('desktop-option', { 'selected-option': selected === eachOption.id })}
                role="radio"
                aria-checked={selected === eachOption.id}
              >
                <p className={cx('option-text')}>{eachOption.text}</p>
              </button>
            );
          }
          return (
            <Button
              customClass={cx('mobile-option', { 'selected-option': selected === eachOption.id })}
              key={eachOption.id}
              ariaLabel={eachOption.text}
              variant="secondary"
              btnLabel={eachOption.text}
              onClick={() => {
                clickHandler(eachOption.id);
              }}
              role="radio"
              ariaChecked={selected === eachOption.id}
            />
          );
        })}
      </div>
    </div>
  );
};

export default RatingFeedBackQA;
